import React from "react";

const thumbStyle = {
  width: 48,
  height: 48,
  objectFit: "cover",
  borderRadius: 4,
};

/** @param {(key: string) => string} tk */
export function getReferenceColumns(tk) {
  return [
    {
      key: "image_url",
      label: tk("columns.image"),
      render: (row) =>
        row.image_url ? (
          <img src={row.image_url} alt="" style={thumbStyle} />
        ) : (
          tk("table.emptyCell")
        ),
    },
    { key: "title_en", label: tk("columns.titleEn") },
    { key: "title_ar", label: tk("columns.titleAr") },
  ];
}
